import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(false);
  const [token, setToken] = useState(null);
  const [mail, setMail] = useState(null);

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    const storedMail = localStorage.getItem('mail');
    if (storedToken) {
      setToken(storedToken);
      setUser(true);
    }
    if (storedMail) {
      setMail(storedMail);
    }
  }, []);

  const storeUserMail = (email) => {
    setMail(email);
    localStorage.setItem('mail', email);
  };

  const userIsAuthenticated = (authToken) => {
    setUser(true);
    setToken(authToken);
    localStorage.setItem('token', authToken);
  };

  const userIsUnauthenticated = () => {
    setUser(false);
    setToken(null);
    setMail(null);
    localStorage.removeItem('token');
    localStorage.removeItem('mail');
  };

  return (
    <AuthContext.Provider value={{
      user,
      token,
      mail,
      storeUserMail,
      userIsAuthenticated,
      userIsUnauthenticated,
    }}>
      {children}
    </AuthContext.Provider>
  );
};